module.exports = __webpack_public_path__ + "img/shibai.4384e137.png";